module.exports = __webpack_public_path__ + "static/media/nMicroloansIcon.b0f9ca39.svg";